import React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import { HeaderWrapper } from '@seedlang/hoc';
import Link from 'components/link';
import Dropdown from 'components/dropdown';
import { CloseIcon, CrownIcon, MenuIcon, DiscordIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import UserProfileImage from 'components/user/user_profile_image';
import MemrevLogo from 'components/memrev_logo';
import GoProButton from 'components/button/go_pro_button';
import { Theme } from '@seedlang/constants';
import HeaderButton from 'components/button/header_button';
import NavigationItemLinks from 'components/layout/desktop/navigation_item_links';
import NotificationsWithPopup from 'components/notification/notifications_with_popup';
import { isPresent } from '@seedlang/utils';
import eventParamsHelper from 'utils/event_params_helper';
import gatekeepDiscordLink from 'utils/gatekeep_discord_link';
import {
  AgreementWrapper,
  DiscordButton,
  Hr,
  InnerWrapper,
  LinkWrapper,
  LogoWrapper,
  MembershipBanner,
  MobileIconWrapper,
  MobileNavigation,
  NavigationButtons,
  Wrapper,
} from 'components/layout/desktop/memrev_header.styles';

export class MemrevHeader extends React.Component {
  static defaultProps = {
    background: Theme.siteHeaderColor,
  };

  render() {
    return (
      <AgreementWrapper>
        {
          this.props.showMemrevMembershipButton && this.props.isMobile &&
            <MembershipBanner
              background={this.props.siteAccentColor || '#1f4d6b'}
            >
              <Link
                to='memberships.index'
                onClick={() => this.props.onClickBecomeMember('mobile_header_banner')}
              >
                <CrownIcon />
                <span>Become a Member</span>
              </Link>
            </MembershipBanner>
        }
        <Wrapper
          background={this.props.background}
          desktopHeaderHeight={this.props.desktopHeaderHeight}
          position={this.props.position}
        >
          {
            this.props.showMobileNavigation && this.props.navigationItems &&
              <MobileNavigation
                top={this.props.showMemrevMembershipButton ? '90px' : '70px'}
                id='mobile-navigation'
              >
                {
                  !this.props.userIsSignedInAndNotGuest &&
                    <Link to='onboarding.sign_in'>
                      <LinkWrapper
                        borderColor='#FFF'
                      >
                        Sign In
                      </LinkWrapper>
                    </Link>
                }
                {
                  !this.props.userIsSignedInAndNotGuest &&
                    <Hr />
                }
                <NavigationItemLinks
                  {...this.props}
                  header
                  flexDirection='column'
                  alignItems='flex-end'
                  afterClick={this.props.onCloseMobileNavigation}
                />
                {
                  this.props.showMobileDiscordLink &&
                    <LinkWrapper
                      as='div'
                      borderColor='transparent'
                    >
                      <a
                        href={this.props.discordButtonHref}
                        target='_blank'
                        rel='noopener noreferrer'
                        onClick={this.props.onClickMobileDiscord}
                      >
                        Discord
                      </a>
                    </LinkWrapper>
                }
                {
                  this.props.userIsSignedInAndNotGuest &&
                    <Hr />
                }
                {
                  this.props.userIsSignedInAndNotGuest &&
                    <LinkWrapper
                      borderColor={this.props.routeName.startsWith('settings.all') ? '#b7b7b7' : 'transparent'}
                    >
                      <Link
                        to='settings.all'
                        onClick={this.props.onCloseMobileNavigation}
                      >
                        Settings
                      </Link>
                    </LinkWrapper>
                }
                {
                  this.props.userIsSignedInAndNotGuest &&
                    <LinkWrapper
                      as='button'
                      type='button'
                      borderColor='#FFF'
                      onClick={this.props.onSignOut}
                      className='on-click'
                    >
                      Sign Out
                    </LinkWrapper>
                }
              </MobileNavigation>
            }
          <InnerWrapper>
            {
              this.props.hasLogo &&
                <LogoWrapper>
                  <Link to={this.props.memrevHomeRoute}>
                    <MemrevLogo />
                  </Link>
                </LogoWrapper>
            }
            <NavigationButtons>
              {
                this.props.showNavigationItems &&
                  <NavigationItemLinks
                    {...this.props}
                    header
                    flexDirection='row'
                  />
              }
              {
                this.props.showDiscordButton &&
                  <DiscordButton
                    href={this.props.discordButtonHref}
                    target='_blank'
                    mobile={this.props.isMobile}
                    isSeedlang={this.props.siteIsSeedlang}
                    onClick={this.props.onClickDiscord}
                  >
                    <DiscordIcon
                      width='22px'
                      fill='currentColor'
                    />
                  </DiscordButton>
              }
              {
                this.props.showMemrevMembershipButton && !this.props.isMobile &&
                  <Link
                    to='memberships.index'
                    onClick={() => this.props.onClickBecomeMember('desktop_header_button')}
                  >
                    <GoProButton
                      marginLeft='15px'
                      height='47px'
                      background={this.props.siteAccentColor}
                      disabled={isPresent(this.props.routeName) && this.props.routeName === 'memberships.index'}
                    >
                      <div className='text'>
                        <span>Become a Member</span>
                      </div>
                    </GoProButton>
                  </Link>
              }
              {
                !this.props.mobileView && !this.props.userIsSignedIn &&
                  <Link
                    to='onboarding.sign_in'
                  >
                    <HeaderButton
                      height='47px'
                      borderRadius='47px'
                      fontWeight='bold'
                      background={this.props.siteAccentColor}
                    >
                      Sign In
                    </HeaderButton>
                  </Link>
              }
              {
                this.props.mobileView &&
                  <MobileIconWrapper
                    type='button'
                    aria-label={
                      this.props.showMobileNavigation
                        ? 'Close navigation menu' : 'Open navigation menu'
                    }
                    aria-controls='mobile-navigation'
                    aria-expanded={this.props.showMobileNavigation}
                    onClick={this.props.onToggleMobileNavigation}
                  >
                    {
                      !this.props.showMobileNavigation &&
                        <MenuIcon />
                    }
                    {
                      this.props.showMobileNavigation &&
                        <CloseIcon />
                    }
                  </MobileIconWrapper>
              }
              {
                this.props.userIsSignedIn && !this.props.mobileView &&
                  <NotificationsWithPopup
                    background='#efefef'
                    hoverBackground={this.props.siteAccentColor || Theme.darkGray}
                    hoverColor='#FFFFFF'
                  />
              }
              {
                !this.props.simplifiedHeader && this.props.userIsSignedIn && !this.props.mobileView &&
                  <Dropdown
                    className='user-profile user-image'
                    top='60px'
                    right={0}
                    backgroundOnHover='gray'
                  >
                    <UserProfileImage
                      hideProStatus
                      hideTooltip
                      margin='0 0 0 15px'
                      padding='0'
                      width={42}
                      user={this.props.user}
                    />
                    <ul>
                      <li>
                        <Link
                          to='settings.user_profile'
                        >
                          Settings
                        </Link>
                      </li>
                      {
                        this.props.user.isMember && (
                          <li>
                            <Link to='memberships.change'>
                              My Membership
                            </Link>
                          </li>
                        )
                      }
                      {
                        this.props.user.currentUserGroup?.admin &&
                            <li>
                              <a href='/creator/posts'>
                                Admin
                              </a>
                            </li>
                      }
                      <li
                        onClick={this.props.onSignOut}
                        className='on-click'
                      >
                        Sign Out
                      </li>
                    </ul>
                  </Dropdown>
              }
            </NavigationButtons>
          </InnerWrapper>
        </Wrapper>
      </AgreementWrapper>
    );
  }
}

@observer
class MemrevHeaderWrapper extends React.Component {
  @observable showMobileNavigation = false;

  signOutAndHideNavigation = () => {
    this.showMobileNavigation = false;
    AppUI.signOut(AppUI.siteIsSeedlang);
  }

  onClickDiscord = () => {
    AppUI.createEvent('memrev - click discord', eventParamsHelper({
      discord_url: this.discordButtonHref,
    }));
  }

  onClickMobileDiscord = () => {
    this.onClickDiscord();
    this.showMobileNavigation = false;
  }

  onClickBecomeMember = source => {
    AppUI.createEvent('memrev - click become a member button', eventParamsHelper({
      source,
      button_text: 'Become a Member',
      source_route: AppUI.routeStore.routeName,
      source_path: window.location.pathname,
      destination_route: 'memberships.index',
    }));
  }

  @computed get mobileView() {
    return AppUI.layout.viewportWidth < 800;
  }

  @computed get showNavigationItems() {
    return !this.mobileView && !this.props.simplifiedHeader && this.props.navigationItems && !!this.props.navigationItems.length;
  }

  @computed get discordButtonHref() {
    if (!isPresent(AppUI.site?.discordServerId)) {
      return null;
    }
    return gatekeepDiscordLink(`https://discord.com/channels/${AppUI.site.discordServerId}`);
  }

  @computed get showDiscordButton() {
    return this.showDiscordLink && !this.mobileView;
  }

  @computed get showDiscordLink() {
    return isPresent(AppUI.site?.discordServerId) && AppUI.site.showDiscordButton;
  }

  @computed get showMobileDiscordLink() {
    return this.showDiscordLink && this.mobileView;
  }

  render() {
    return (
      <MemrevHeader
        {...this.props}
        desktopHeaderHeight={AppUI.layout.desktopHeaderHeight}
        discordButtonHref={this.discordButtonHref}
        hasLogo={!!AppUI.site?.image}
        isMobile={AppUI.layout.isMobile}
        mobileView={this.mobileView}
        onClickBecomeMember={this.onClickBecomeMember}
        onClickDiscord={this.onClickDiscord}
        onClickMobileDiscord={this.onClickMobileDiscord}
        onCloseMobileNavigation={() => this.showMobileNavigation = false}
        onSignOut={this.signOutAndHideNavigation}
        onToggleMobileNavigation={() => this.showMobileNavigation = !this.showMobileNavigation}
        routeName={AppUI.routeStore.routeName}
        showDiscordButton={this.showDiscordButton}
        showMobileDiscordLink={this.showMobileDiscordLink}
        showMobileNavigation={this.showMobileNavigation}
        showNavigationItems={this.showNavigationItems}
        siteAccentColor={AppUI.site?.accentColor}
        siteIsSeedlang={AppUI.siteIsSeedlang}
        user={AppUI.user}
        userIsSignedIn={AppUI.userIsSignedIn}
        userIsSignedInAndNotGuest={AppUI.userIsSignedInAndNotGuest}
      />
    );
  }
}

export { MemrevHeaderWrapper };
export default HeaderWrapper(MemrevHeaderWrapper);
